// src/pages/Home.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '../components/SEO/PageMeta';
import StructuredData from '../components/SEO/StructuredData';

// Page sections
import Hero from '../components/Hero';
import SolutionAreas from '../components/home/SolutionAreas';
import DataFlow from '../components/home/DataFlow';
import UseCases from '../components/home/UseCases';
import EdgeJetson from '../components/home/EdgeJetson';
import WhyRobomind from '../components/home/WhyRobomind';
import HomeFaq from '../components/home/HomeFaq';
import CtaBanner from '../components/CtaBanner';
import Clients from '../components/Clients';
import LinkedInFeed from '../components/LinkedIn/LinkedInFeed';

const Home = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageMeta
                title={t('homepage_meta.title')}
                description={t('homepage_meta.description')}
                keywords={t('homepage_meta.keywords')}
                path="/"
            />

            {/* Structured Data (JSON-LD) */}
            <StructuredData type="homepage" />

            <Hero />
            <SolutionAreas />
            <DataFlow />
            <UseCases />
            <EdgeJetson />
            <WhyRobomind />
            <Clients />
            <LinkedInFeed maxPosts={3} />
            <HomeFaq />
            <CtaBanner
                title={t('home.cta.title')}
                text={t('home.cta.text')}
                buttonLabel={t('home.cta.button')}
            />
        </>
    )
}

export default Home;
